import environments from '@app/configs/environments';

export const baseAPIurl = environments.api.apiUrl;
